import { v4 as uuidv4 } from 'uuid';

import { actions } from 'src/constants';

import { getActionType } from './helper';

export const set = (namespace, identifier, payload) => ({
  type: getActionType(actions.ACTION_SET, namespace, identifier),
  payload
});

export const remove = (namespace, identifier) => ({
  type: getActionType(actions.ACTION_REMOVE, namespace, identifier)
});

export const setFilters = (Model) => (filters) => (dispatch) => dispatch(
  set(Model.NAME, 'filters', filters)
);

export const setSortBy = (Model) => (sortBy) => (dispatch) => dispatch(
  set(Model.NAME, 'sortBy', sortBy)
);

export const setPagination = (Model) => (pagination) => (dispatch) => dispatch(
  set(Model.NAME, 'pagination', pagination)
);

export const setIsFetching = (Model) => (isFetching = true, fetched = false) => set(
  Model.NAME, 'list', { isFetching, fetched }
);

export const addOneNotification = (config = {}) => (dispatch) => {
  const id = uuidv4(); // assign a temp, unique, id to notification

  dispatch({
    type: getActionType(actions.OPEN_ONE_NOTIFICATION, 'notifications'),
    config: { ...config, id }
  });
};

export const addManyNotifications = (config = []) => (dispatch) => {
  const notifications = config.map((notification) => ({
    ...notification,
    id: uuidv4()
  }));

  dispatch({
    type: getActionType(actions.OPEN_MANY_NOTIFICATIONS, 'notifications'),
    config: notifications
  });
};

export const removeNotification = (config) => (dispatch) => dispatch({
  type: getActionType(actions.CLOSE_NOTIFICATION, 'notifications'),
  config // remove based on unique, temporary, id in config
});
